<template>
    <div class="space-y-8 flex flex-col min-h-full bg-light-gray pb-8">
        <div class="space-y-0 lg:space-y-4 flex-1 pt-4">
            <div class="max-w-7xl mx-auto p-2 lg:p-0">
                <div class="flex justify-between items-center">
                    <CompanyBrand :company="bookingFormCompany" />
                </div>
            </div>

            <div class="p-2 lg:p-0">
                <div
                    class="min-h-[650px] mx-auto bg-white border border-gray-200 rounded-xl"
                    :class="containerClasses"
                >
                    <div
                        v-if="
                            showCoverImage &&
                            bookingFormCompany.shouldRenderCoverImage()
                        "
                    >
                        <div
                            class="max-h-60 min-h-60 w-full rounded-t-xl overflow-hidden"
                        >
                            <Image
                                class="max-h-60 min-h-60 w-full object-cover"
                                :class="{
                                    'object-top':
                                        bookingFormCompany.isCoverImageTopPositioned(),
                                    'object-center':
                                        bookingFormCompany.isCoverImageCenterPositioned(),
                                    'object-bottom':
                                        bookingFormCompany.isCoverImageBottomPositioned(),
                                }"
                                :src="bookingFormCompany.getCoverImage().url"
                            />
                        </div>
                    </div>

                    <div class="py-8 px-4 lg:px-8 space-y-8">
                        <slot name="content"></slot>
                    </div>
                </div>
            </div>
        </div>

        <GetYourOwnTinyCalPage
            v-if="isFreePlan"
            :currentLocale="currentLocale"
        />
        <Footer
            :appName="appName"
            :currentLocale="currentLocale"
            :openCookieSettingsElementId="openCookieSettingsElementId"
        >
            <template #right>
                <LocaleDropdown
                    :currentLocaleEnumData="currentLocaleEnumData"
                />
            </template>
        </Footer>
    </div>
</template>

<script setup lang="ts">
    import Company from '@/App/Company/Entity/Company'
    import Customer from '@/App/Customer/Entity/Customer'
    import CompanyBrand from '@/BookingForm/BookingForm/Component/CompanyBrand.vue'
    import GetYourOwnTinyCalPage from '@/BookingForm/BookingForm/Component/GetYourOwnTinyCalPage.vue'
    import Footer from '@/BookingForm/BookingForm/Component/Footer.vue'
    import LocaleDropdown from '@/Shared/Component/LocaleDropdown.vue'
    import type {
        LocaleEnum,
        LocaleEnumDataEntry,
    } from '@/Shared/AutoGenerated/LocalizationEnum'
    import Image from '@/Shared/Component/Image.vue'

    // --------------
    // TODO: This must be in sync with other pages defining "BookingFormLayoutProps" interface :(
    // --------------
    interface BookingFormLayoutProps {
        appName: string
        isFreePlan: boolean
        bookingFormCompany: Company
        authCustomer: Customer | null
        errorMessage: string | null
        googleSocialLoginEnabled: boolean
        currentUrl: string
        containerClasses: string
        showCoverImage: boolean
        currentLocale: LocaleEnum
        currentLocaleEnumData: LocaleEnumDataEntry
        openCookieSettingsElementId: string
    }

    const props = defineProps<BookingFormLayoutProps>()
</script>
